import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (comment) =>
    present(
      repository
        .removeComment(comment)
        .then(() => comment)
        .catch(() => Promise.reject(comment)),
    );
}

export type { Interactor };

export { createInteractor };
